window.addEventListener('DOMContentLoaded', function (e) {
	const header = document.querySelector('header.header')
	const parentLinks = header.querySelectorAll('li.parent')

	if (window.innerWidth < 1200) {
		parentLinks.forEach(toggleMenu)
	}

	window.addEventListener('resize', e => {
		if (window.innerWidth < 1200) {
			parentLinks.forEach(toggleMenu)
		}
	})

	function toggleMenu(el) {
		let link = el

		link.onclick = function (e) {
			if (e.target.tagName !== 'A') {
				const isExpanded = el.classList.contains('expanded')

				document.querySelectorAll('li.parent').forEach(li => {
					li.classList.remove('expanded')
				})

				el.classList.toggle('expanded', !isExpanded)
			}
		}
	}

	// Hamburger functionality
	let hamburger = header.querySelector('.hamburger-wrapper')
	if (hamburger) {
		let startY

		hamburger.addEventListener('click', function (e) {
			hamburger.classList.toggle('active')
			startY = window.scrollY
		})
		window.addEventListener('click', function (e) {
			if (!e.target.closest('nav') && !e.target.closest('.hamburger')) {
				hamburger.classList.remove('active')
			}
		})
		window.addEventListener('scroll', function (e) {
			if (Math.abs(window.scrollY - startY) >= 500) {
				hamburger.classList.remove('active')
			}
		})
	}

	// Helpful links functionality
	let helpfulLinks = header.querySelectorAll('.helpful-links')
	helpfulLinks.forEach(group => {
		group.addEventListener('click', e => {
			e.stopImmediatePropagation()
			group.classList.toggle('active')
		})
	})

	// Sticky nav functionality
	let previousScrollTop = 0
	window.addEventListener('scroll', e => {
		let currentScrollTop = window.scrollY

		if (previousScrollTop - currentScrollTop < 0 && currentScrollTop > 150) {
			header.classList.add('scrolled-down')
			hamburger.classList.remove('active')
		} else {
			header.classList.remove('scrolled-down')
		}

		previousScrollTop = currentScrollTop
	})
	document.documentElement.style.setProperty(
		'--header-offset',
		`${header.scrollHeight}px`,
	)
	window.addEventListener('resize', () => {
		document.documentElement.style.setProperty(
			'--header-offset',
			`${header.scrollHeight}px`,
		)
	})
})
